import React, { useEffect } from "react";
import { useBotStore } from "./stores/botStore";
import BotHeader from "./components/BotHeader";
import SettingsTab from "./components/SettingsTab/SettingsTab";
import CancellationQueueTab from "./components/CancellationQueueTab/CancellationQueueTab";
import { Loading } from "components";

// Головний компонент сторінки "Керування ботом"
const BotSettingsPage = () => {
  // Отримуємо необхідні дані та дії зі стору
  const activeTab = useBotStore((state) => state.activeTab);
  const isLoading = useBotStore((state) => state.isLoading);
  const init = useBotStore((state) => state.init);

  // Ефект для початкової ініціалізації при першому завантаженні сторінки
  useEffect(() => {
    init();
  }, [init]);

  return (
    <section id="botsettingspage">
      <div className="page-container">
        <BotHeader />
        {isLoading ? (
          <Loading />
        ) : activeTab === "queue" ? (
          <CancellationQueueTab />
        ) : (
          <SettingsTab />
        )}
      </div>
    </section>
  );
};

export default BotSettingsPage;
